import styled from "styled-components";

export const SocialNetworksContainer = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;

    @media (min-width: 640px) and (max-width: 1023px)
    {
        width: 100%;
        justify-content: center;
        flex-wrap: nowrap;
        gap: 10%;
    }
`;

export const SocialButtonLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 32px;
    min-width: 56px;
    min-height: 32px;
    padding: 0;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 32px;
    color: inherit;
    text-decoration: none;
    transition: background 0.2s ease, opacity 0.2s ease;
    flex-shrink: 0;

    &:hover
    {
        background: rgba(255, 255, 255, 0.2);
        opacity: 1;
    }

    &:visited
    {
        color: inherit;
    }

    svg
    {
        display: block;
        width: 20px;
        height: 20px;
        max-width: 20px;
        max-height: 20px;
        flex-shrink: 0;
    }
`;
